
































import { Component, Vue } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import MerchantService from '@/api/MerchantService';
import { EConnectionTypeOauth, IConnectOauth } from '../../../models/provider';
import { NOTIFICATION_MESSAGE_STORAGE } from '@/models/notification';

@Component({
  components: {
    Typography,
    Picture,
    FilledButton
  }
})
export default class CustomToast extends Vue {
  merchantService = new MerchantService();
  connectedProviders: IConnectOauth[] = [];
  connectionsOutdated: IConnectOauth[] = [];
  shouldUpdate = false;
  loading = false;

  mounted() {
    this.$store.watch(
      (_, getters) => getters['merchant/getConnectedProvidersList'],
      connectedProviders => this.initialize(connectedProviders)
    );
  }

  async initialize(connectedProviders: IConnectOauth[]) {
    if (!connectedProviders) return;
    this.connectedProviders = connectedProviders.filter(
      connectedProvider => connectedProvider.provider !== 'fidel'
    );

    const isConnectionRoute = window.location.href.includes('merchant-connect');
    if (this.connectedProviders.length && !isConnectionRoute) {
      setTimeout(async () => {
        const shouldUpdateList = await Promise.all(
          this.connectedProviders.map(async connectedProvider => {
            const shouldUpdate = await this.shouldUpdateProviderApp(
              connectedProvider
            );

            if (shouldUpdate) {
              this.connectionsOutdated.push(connectedProvider);
            }

            return shouldUpdate;
          })
        );

        this.$store.dispatch(
          'merchant/SET_PROVIDERS_TO_UPDATE',
          this.connectionsOutdated
        );

        this.shouldUpdate = !!shouldUpdateList.find(v => !!v);
      }, 2000);
    }
  }

  async shouldUpdateProviderApp(oauth?: IConnectOauth): Promise<boolean> {
    if (oauth) {
      try {
        const response = await this.merchantService.shouldUpdate(oauth.id);

        return response.data.needsUpdateScope;
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  async onSubmitUpdateScopes() {
    try {
      this.loading = true;
      if (this.connectionsOutdated.length > 0) {
        const connection = this.connectionsOutdated.pop();
        const response =
          connection &&
          (await this.merchantService.updateScopes(connection.id));

        this.shouldUpdate = false;

        if (response && response.data.url) {
          if (
            connection &&
            connection.connectionType === EConnectionTypeOauth.OAUTH
          ) {
            localStorage.setItem(
              NOTIFICATION_MESSAGE_STORAGE,
              'Connected provider updated succesfully'
            );
          }

          window.open(response.data.url, '_blank');
        } else {
          this.$notification('Connected provider updated succesfully');
        }
      }
    } finally {
      this.loading = false;
    }
  }

  onClose() {
    this.shouldUpdate = false;
  }
}
